module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/SingleAlbum-09ce66dc42e0f217b4668f842afac097.jpg";